import React, { useEffect, useState, useCallback } from "react";
import { history } from "../../../../store/configure/configureStore";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaFilter,
  FaArrowLeftLong,
} from "react-icons/fa6";
import { MdDelete, MdSearch } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { capitalizeWords } from "../../../../utils/common";
import { Role } from "../../../../constants/role";
import { USERS, TOPICS } from "../../../../constants/constants";
import Nav from "react-bootstrap/Nav";

import { Header, DataTable } from "../../../common";
import {
  IconMenuOption,
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
  Checkbox,
} from "../../../controls";
import { MobileUsersList, TopicList } from "./Components";

import "./SendNotificationStyles.scss";

const SendNotificationView = ({
  //
  mobileUserList,
  topicList,
  fields,
  userData,
  sendNotificationForAllCheckbox,
  showModal,
  selectedRowsData,
  selectedRowsDataOfTopic,
  currentPage,
  rowsPerPage,
  errors,
  //
  onChangeSearchInput,
  //
  handleInputChange,
  handleClear,
  handleTableRowsChange,
  handleChangePage,
  handleCheckBoxChange,
  //
  handleSelectedRows,
  handleSelectedRowsOfTopic,
  resetSelectedRowsOnTabChange,
  //
  onClickViewUser,
  onTabChangeShowWarningModal,
  handleCloseModal,
  //
  onClickSearch,
  onClickSend,
  //
  rowsPerPageDropDownOptions,
  //
  subscriptionList,
  //
  onClickSubscriptionDropDownFilterOptions,
  persistedData,
  //
  updateSendNotificationTabs,
  //
  userPermissions,
  userRole,
  //
  activeSendNotificationTab,
  //
  onClickCancel,
}) => {
  // console.log("userData", userPermissions);
  const [showSelection, setShowSelection] = useState(true);
  const [showSelectionForTopics, setShowSelectionForTopics] = useState(true);
  const [activeTabNav, setActiveTabNav] = useState(activeSendNotificationTab);
  const [proceedingTab, setProceedingTab] = useState(null);

  const renderCommaSeparatedSubscriptions = (subscriptions) => {
    if (!subscriptions || subscriptions.length === 0) return "-"; // Return "-" if no subscriptions

    return subscriptions
      .map(
        (sub) =>
          `${sub.name || ""}${
            sub.subscriptionOfferingName
              ? ", " + sub.subscriptionOfferingName
              : ""
          }`
      )
      .join(", ");
  };

  // const renderCommaSeparatedTopics = (topicMappingCollectionId) => {
  //   if (!topicMappingCollectionId || topicMappingCollectionId.length === 0)
  //     return "-"; // Return "-" if no topics

  //   return topicMappingCollectionId
  //     .map((topic) => topic.topicId?.name || "")
  //     .filter((name) => name) // Filter out any empty or undefined names
  //     .join(", ");
  // };

  const renderCommaSeparatedTopics = (topicMappingCollectionId) => {
    if (!topicMappingCollectionId || topicMappingCollectionId.length === 0) {
      return "-"; // Return "-" if no topics
    }

    return topicMappingCollectionId
      .map((topic) => topic.name || "") // Access the 'name' property directly
      .filter((name) => name) // Filter out any empty or undefined names
      .join(", ");
  };

  const renderToken = (token) => {
    if (!token || token.length === 0) return "-"; // Return "-" if no tokens

    return (
      <>
        {token.map((item, index) => (
          <span key={index}>
            {item.token}
            {index < token.length - 1 && ( // Conditionally add two <br /> tags if it's not the last token
              <>
                <br />
                <br />
              </>
            )}
          </span>
        ))}
      </>
    );
  };

  //--------------------------View modal UI
  const renderViewBody = () => {
    const user = [
      { label: "Name", value: capitalizeWords(userData?.name) || "-" },
      { label: "Email", value: userData?.email || "-" },
      {
        label: "Subscription",
        value:
          renderCommaSeparatedTopics(
            userData?.customParameters?.topicMappingCollectionId
          ) || "-",
        // renderCommaSeparatedSubscriptions(userData?.subscriptions) || "-",
      },
      {
        label: "Sky Attended",
        value: userData?.isMandatoryWorkshopAttended ? "Yes" : "No" || "-",
      },
      {
        label: "Sahaj Attended",
        value: userData?.isSahajGraduate ? "Yes" : "No" || "-",
        isLastItem: true,
      },
      // {
      //   label: "Token",
      //   // value: userData?.token || "-",
      //   value: renderToken(userData?.token) || "-",
      //   isToken: true,
      //   isLastItem: true,
      // },
    ];

    return (
      <div className="body-content-wrapper--send-notification view-body-mobile-user">
        <div className="content-wrapper">
          {user.map((item, index) => (
            <div key={index}>
              <div
                className={`wrapper ${item.isLastItem && "no-bottom-border"}`}
              >
                <span className="label-wrapper">{item.label}</span>
                <span className="partition">:</span>
                <span
                  className={`content ${item.isToken && "wrap-content"} ${
                    (userData?.token?.length === 1 ||
                      userData?.token?.length === 0) &&
                    "content-wrap-fit-content"
                  }`}
                >
                  {item.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const memoizedHandleSelectedRows = useCallback(
    ({ selectedRows }) => {
      // console.log("selectedRows", selectedRows);
      handleSelectedRows(selectedRows);
    },
    [handleSelectedRows]
  );

  const memoizedHandleSelectedRowsOfTopic = useCallback(
    ({ selectedRows }) => {
      // console.log("selectedRows", selectedRows);
      handleSelectedRowsOfTopic(selectedRows);
    },
    [handleSelectedRowsOfTopic]
  );

  //--------------------------show Warning modal when tab change or page change

  const renderNavigatingToOtherTabWarningBody = () => {
    return (
      <div className="body-content-wrapper warning-body">
        <div>All selections will be discarded.</div>
      </div>
    );
  };

  const onClickProceed = () => {
    setActiveTabNav(proceedingTab);
    updateSendNotificationTabs(proceedingTab);
    resetSelectedRowsOnTabChange();
    handleCloseModal();
  };

  const renderNavigatingToOtherTabWarningFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Proceed"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              onClickProceed();
            }}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              handleCloseModal();
            }}
          />
        </div>
      </div>
    );
  };

  //--------------------------Tab UI
  function navigationTabs() {
    // const videosByDailyCronType =
    //   youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    // const videosByUrlType = youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    // const handleSelect = (selectedKey) => {
    //   if (showSelection) {
    //     setNavigatingToOtherTabWarningModal(selectedKey); // Show warning modal
    //     showTabChangePopup();
    //   } else {
    //     setActiveTabNav(selectedKey); // Update active tab
    //   }
    // };

    const handleSelect = (selectedKey) => {
      if (
        sendNotificationForAllCheckbox ||
        selectedRowsDataOfTopic?.length > 0 ||
        selectedRowsData?.length > 0
      ) {
        onTabChangeShowWarningModal();
        setProceedingTab(selectedKey);
      } else {
        setActiveTabNav(selectedKey); // Update active tab
        updateSendNotificationTabs(selectedKey);
      }
    };

    return (
      <Nav
        className={"tab-navigation-wrapper"}
        variant="tabs"
        // activeKey={
        //   activeTabNav
        //     ? activeTabNav
        //     : youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON
        // }
        activeKey={activeTabNav}
        onSelect={(selectedKey) => handleSelect(selectedKey)} // Handle tab selection manually
      >
        <Nav.Item className="nav-item">
          <Nav.Link
            className="text-bold"
            eventKey={USERS}
            onClick={(e) => {
              if (selectedRowsDataOfTopic?.length > 0) {
                e.preventDefault();
                onTabChangeShowWarningModal();
              }
            }}
          >
            Users
          </Nav.Link>
        </Nav.Item>
        {/* <Nav.Item>
          <Nav.Link
            eventKey={TOPICS}
            onClick={(e) => {
              if (selectedRowsData?.length > 0) {
                e.preventDefault();
                onTabChangeShowWarningModal();
              }
            }}
          >
            Topics
          </Nav.Link>
        </Nav.Item> */}
      </Nav>
    );
  }

  const mobileUserListComponent = (
    <MobileUsersList
      mobileUserList={mobileUserList}
      userRole={userRole}
      selectedRowsData={selectedRowsData}
      subscriptionList={subscriptionList}
      onClickSubscriptionDropDownFilterOptions={
        onClickSubscriptionDropDownFilterOptions
      }
      persistedData={persistedData}
      onClickViewUser={onClickViewUser}
      handleTableRowsChange={handleTableRowsChange}
      handleChangePage={handleChangePage}
      currentPage={currentPage}
      sendNotificationForAllCheckbox={sendNotificationForAllCheckbox}
      showSelection={showSelection}
      memoizedHandleSelectedRows={memoizedHandleSelectedRows}
    />
  );

  const topicListComponent = (
    <TopicList
      topicList={topicList}
      userRole={userRole}
      selectedRowsDataOfTopic={selectedRowsDataOfTopic}
      subscriptionList={subscriptionList}
      onClickSubscriptionDropDownFilterOptions={
        onClickSubscriptionDropDownFilterOptions
      }
      persistedData={persistedData}
      onClickViewUser={onClickViewUser}
      handleTableRowsChange={handleTableRowsChange}
      handleChangePage={handleChangePage}
      currentPage={currentPage}
      sendNotificationForAllCheckbox={sendNotificationForAllCheckbox}
      showSelectionForTopics={showSelectionForTopics}
      memoizedHandleSelectedRowsOfTopic={memoizedHandleSelectedRowsOfTopic}
    />
  );

  const renderList = () => {
    const componentMapping = {
      Users: mobileUserListComponent,
      Topics: topicListComponent,
    };

    const activeNavTab = activeTabNav;

    const activeNavTable = componentMapping[activeNavTab];

    return (
      <div className="send_notification_mobile__app_user_management--table-wrapper">
        {activeNavTab === USERS && (
          <div className="controls-wrapper">
            <span className="action-controls-block">
              <div className="row-control-wrapper">
                <Select
                  value={rowsPerPage}
                  placeholder={10}
                  options={rowsPerPageDropDownOptions}
                  onChange={(val) => {
                    handleTableRowsChange(val);
                  }}
                  isRowCap={true}
                />
                entries per page
              </div>
              <div className="row-control-wrapper">
                <Checkbox
                  checked={sendNotificationForAllCheckbox}
                  iconSize={10}
                  text={"Send notification for all users"}
                  checkboxLabelStyles={"checkboxLabel"}
                  onChange={(e) => {
                    handleCheckBoxChange();
                  }}
                />
              </div>
            </span>
            <div className="row-control-wrapper">
              Search:{" "}
              <Input
                name={"searchString"}
                value={fields?.searchString}
                isrequired={true}
                onChange={(e) => onChangeSearchInput(e)}
                placeholder={"Type here to search"}
                showClearIcon={fields?.searchString ? true : false}
                handleClear={handleClear}
                error={errors["searchString"]}
                isSearchInput={true}
                autocomplete="off"
              />
              <div className="search-action-wrapper">
                <ButtonView
                  // title="Search"
                  icon={<MdSearch size={20} color="#eca55a" />}
                  styles={"secondary"}
                  size={"medium btn"}
                  onClick={() => onClickSearch()}
                />
              </div>
            </div>
          </div>
        )}
        <div className="table-content">{activeNavTable}</div>
      </div>
    );
  };

  //send button disable
  const isSendButtonDisabledForMobileUsersTab =
    selectedRowsData?.length === 0 && !sendNotificationForAllCheckbox
      ? true
      : false;

  const isSendButtonDisabledForTopicTab =
    selectedRowsDataOfTopic?.length === 0 ? true : false;

  const disabled =
    activeSendNotificationTab === USERS
      ? isSendButtonDisabledForMobileUsersTab
      : isSendButtonDisabledForTopicTab;

  const Title =
    activeSendNotificationTab === USERS
      ? "Select Mobile Users"
      : "Select Topic";

  // console.log("mobileUserList Updated", mobileUserList);
  return (
    <div className="send_notification_mobile__app_user_management--container">
      <div className="send_notification_mobile__app_user_management--header-wrapper">
        <div className="action">
          <FaArrowLeftLong size={25} onClick={onClickCancel} />
        </div>
        <div className="selection-block">
          <div className="title-content">{Title}</div>{" "}
        </div>
        <div className="action-block">
          <div className="action-btn-wrapper">
            {userPermissions?.includes("add_user") && (
              <ButtonView
                title="Cancel"
                styles={"light"}
                // icon={<FaPlus />}
                onClick={() => history.goBack()}
              />
            )}
          </div>
          <div className="action-btn-wrapper">
            {userPermissions?.includes("add_user") && (
              <ButtonView
                title="Send"
                styles={"secondary"}
                // icon={<FaPlus />}
                onClick={() => onClickSend()}
                disabled={disabled}
              />
            )}
          </div>
        </div>
      </div>
      <div className="youtube__management--navigationTab">
        {navigationTabs()}
      </div>
      {renderList()}
      {/* <div className="send_notification_mobile__app_user_management--table-wrapper">
        <div className="controls-wrapper">
          <span className="action-controls-block">
            <div className="row-control-wrapper">
              <Select
                value={rowsPerPage}
                placeholder={10}
                options={rowsPerPageDropDownOptions}
                onChange={(val) => {
                  handleTableRowsChange(val);
                }}
              />{" "}
              entries per page
            </div>
            <div className="row-control-wrapper">
              <Checkbox
                checked={sendNotificationForAllCheckbox}
                iconSize={10}
                text={"Send notification for all users"}
                checkboxLabelStyles={"checkboxLabel"}
                onChange={(e) => {
                  handleCheckBoxChange();
                }}
              />
            </div>
          </span>
          <div className="row-control-wrapper">
            Search:{" "}
            <Input
              name={"searchString"}
              value={fields?.searchString}
              isrequired={true}
              onChange={(e) => onChangeSearchInput(e)}
              placeholder={"Type here to search"}
              showClearIcon={fields?.searchString ? true : false}
              handleClear={handleClear}
              error={errors["searchString"]}
              isSearchInput={true}
              autocomplete="off"
            />
            <div className="search-action-wrapper">
              <ButtonView
                // title="Search"
                icon={<MdSearch size={20} color="#eca55a" />}
                styles={"secondary"}
                size={"medium btn"}
                onClick={() => onClickSearch()}
              />
            </div>
          </div>
        </div>
        <div className="table-content">
          <DataTable
            keyField={"_id"}
            columns={columns}
            data={mobileUserList?.docs ? mobileUserList?.docs : []}
            highlightOnHover={true}
            pointerOnHover={true}
            fixedHeader={true}
            //
            pagination={true}
            paginationServer={true}
            paginationPerPage={mobileUserList?.limit}
            paginationTotalRows={mobileUserList?.totalDocs}
            onChangeRowsPerPage={handleTableRowsChange}
            onChangePage={handleChangePage}
            currentPage={currentPage}
            //
            selectableRows={!sendNotificationForAllCheckbox && showSelection}
            clearSelectedRows
            onSelectedRowsChange={memoizedHandleSelectedRows}
            //
            customStyles={customStyles}
          />
        </div>
      </div> */}
      <ModalView
        show={showModal.showViewModal}
        handleClose={handleCloseModal}
        center={true}
        size={"lg"}
        showCloseIcon={true}
        title={"User Details"}
        children={renderViewBody()}
      />
      <ModalView
        show={showModal.showWarningForRowTagsWhenNavigatingToOtherTab}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Attention"}
        size={"md"}
        children={renderNavigatingToOtherTabWarningBody()}
        footer={renderNavigatingToOtherTabWarningFooter()}
      />
    </div>
  );
};

export default SendNotificationView;
